module.exports = __webpack_public_path__ + "assets/img/11_1100_big.ce16d6bc.jpg";